function cov_4xvov6jlg() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/EventCard/EventCardChip.tsx";
  var hash = "dc8b8ecb2d0eb6f7ad3f24d686365db3d6c65eb8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/EventCard/EventCardChip.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 50
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 29,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 50
          },
          end: {
            line: 10,
            column: 51
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 29,
            column: 9
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 7
          },
          end: {
            line: 27,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 7
          },
          end: {
            line: 23,
            column: 17
          }
        }, {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 26,
            column: 15
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dc8b8ecb2d0eb6f7ad3f24d686365db3d6c65eb8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_4xvov6jlg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_4xvov6jlg();
import React from 'react';
import { Flex, Text } from '@opendoor/bricks/core';
cov_4xvov6jlg().s[0]++;

/** TODO: Add documentation */
export var EventCardChip = function EventCardChip(_ref) {
  var firstLine = _ref.firstLine,
      secondLine = _ref.secondLine;
  cov_4xvov6jlg().f[0]++;
  cov_4xvov6jlg().s[1]++;
  return /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center",
    height: "44px",
    bg: "neutrals100",
    px: 3,
    borderRadius: "roundedSquare"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "neutrals0",
    fontWeight: "semibold",
    size: "s00",
    lineHeight: 1
  }, firstLine), (cov_4xvov6jlg().b[0][0]++, secondLine) && (cov_4xvov6jlg().b[0][1]++, /*#__PURE__*/React.createElement(Text, {
    color: "neutrals0",
    fontWeight: "semibold",
    size: "s00",
    lineHeight: 1,
    mt: 1
  }, secondLine))));
};